<script>
export default {
    name: "StockJournalList",

    data() {

        return {
            journals: [],
            filter: {
                date: window.moment().format('YYYY-MM-DD'),
            },
            userName: this.$root.username,
        };
    },

    mounted () {

        this.fetchAll();
    },

    methods: {

        fetchAll () {

            this.$root.loading = true;
            this.$accountsHttp.get(`InventoryJournal/GetInventoryJournals?UserName=${this.userName}&Date=${this.date}`)
                .then(response => { this.journals = response.data; this.$root.loading = false; })
                .catch(() => { this.$root.loading = false; });
        },
    }
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
                <template v-slot:card-header>
                    <h5 class="text-sm font-medium">Stock Journal Listing</h5>
                </template>
                <template v-slot:card-body>
                    <div class="flex w-full">
                        <div class="w-1/4 p-tiny">
                            <input type="date" v-model.trim="filter.date" id="date" class="input-control input-sm text-xs">
                        </div>
                        <div class="w-1/12 p-tiny">
                            <button class="btn-sm btn-info text-xs rounded" @click.prevent="fetchAll"><i class="fa fa-filter"></i> Filter</button>
                        </div>
                    </div>
                    <div class="w-full overflow-auto">
                        <table class="table table-hover">
                            <thead class="bg-blue-500 text-xs text-white">
                                <tr class="w-full flex">
                                    <th class="p-tiny w-1/6">Date</th>
                                    <th class="p-tiny w-1/6">Code</th>
                                    <th class="p-tiny w-1/6">Name</th>
                                    <th class="p-tiny w-1/12">Ref</th>
                                    <th class="p-tiny w-1/6">Description</th>
                                    <th class="p-tiny w-1/12">Qty</th>
                                    <th class="p-tiny w-1/12">Unit Price</th>
                                    <th class="p-tiny w-1/12">Username</th>
                                </tr>
                            </thead>
                            <tbody class="flex flex-col items-center text-xs bg-gray-100 overflow-auto" style="height:70vh;">
                                <tr class="flex w-full" v-for="(journal, idx) in journals" :key="idx">
                                    <td class="p-tiny w-1/6">{{ journal.date | dateFormat }}</td>
                                    <td class="p-tiny w-1/6">{{ journal.deductionID }}</td>
                                    <td class="p-tiny w-1/6">{{ journal.item }}</td>
                                    <td class="p-tiny w-1/12">{{ journal.batchNo }}</td>
                                    <td class="p-tiny w-1/6">{{ journal.description }}</td>
                                    <td class="p-tiny w-1/12">{{ journal.qty }}</td>
                                    <td class="p-tiny w-1/12">{{ journal.price }}</td>
                                    <td class="p-tiny w-1/12">{{ journal.userName }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
                <template v-slot:card-footer>
                    <div class="w-full text-right">
                      <router-link :to="{ name: `inventory-management.index` }" class="btn-sm btn-danger text-xs rounded"><i class="fa fa-caret-left"></i> Back</router-link>
                    </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>
